import { AleService, AleSession, mopConfigWeb } from '@netflix-internal/ale-client';

/** Resolves an ALE keyProvResponse string from a keyProvRequest string. */
export type AleKeyProvisioner = (keyProvRequest: string) => Promise<string>;

export class ALEClient {
  private readonly provisionKey: AleKeyProvisioner;
  private readonly aleService: AleService;
  private session: AleSession | null = null;
  private provisionPromise: Promise<AleSession> | null = null;

  constructor(
    provisionKey: AleKeyProvisioner,
    aleService: AleService = new AleService(mopConfigWeb()),
  ) {
    this.provisionKey = provisionKey;
    this.aleService = aleService;
  }

  async encrypt(plaintext: string): Promise<{ ciphertext: string; token: string }> {
    await this.ensureSession();
    const ciphertext = await this.session!.encryptString(plaintext);
    const token = this.session!.getToken();
    return { ciphertext, token };
  }

  private async ensureSession(): Promise<void> {
    if (this.session && !this.session.shouldRenew()) {
      return;
    }

    if (!this.provisionPromise) {
      this.provisionPromise = this.provision().finally(() => {
        this.provisionPromise = null;
      });
    }

    this.session = await this.provisionPromise;
  }

  private async provision(): Promise<AleSession> {
    const provRequest = await this.aleService.getProvisioningRequest();
    const keyProvResponse = await this.provisionKey(provRequest);
    return this.aleService.createSession(keyProvResponse);
  }
}
